import { useState } from "react";

export function ConfirmSubscription() {
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
  const [message, setMessage] = useState("Confirm only if you want to receive Deposit Seed House email offers. You can unsubscribe at any time.");
  const [pending, setPending] = useState(false);
  const [done, setDone] = useState(false);
  async function confirm() {
    setPending(true);
    try {
      const response = await fetch("/api/marketing/confirm", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ token }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data?.error?.message || "Unable to confirm subscription.");
      setMessage("Your subscription is confirmed."); setDone(true);
      history.replaceState(null, "", window.location.pathname);
    } catch (error) { setMessage(error instanceof Error ? error.message : "Unable to confirm subscription."); }
    finally { setPending(false); }
  }
  return <section className="section"><h1>Confirm email offers</h1><p role="status">{message}</p>
    {!done && <button className="button button--primary" disabled={pending || !token} onClick={confirm}>Confirm subscription</button>}
  </section>;
}
